// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './permission';
import router from './router'
import store from './store'  //引入状态管理store
import Clipboard from 'clipboard';

import { Popup, PasswordInput, NumberKeyboard,Button,Toast,Icon,Dialog,Swipe,SwipeItem,Lazyload,Tab,Tabs,Sticky,Loading,Tabbar,TabbarItem,Cell, CellGroup,Checkbox,CheckboxGroup,Col, Row ,Search} from 'vant';
import { sendRecord, sendPV } from "./utils/buriedpoint";
Vue.use(Popup).use(PasswordInput).use(NumberKeyboard).use(Button).use(Toast).use(Icon).use(Dialog).use(Swipe).use(SwipeItem).use(Lazyload)
.use(Tab).use(Tabs).use(Sticky).use(Loading).use(Tabbar).use(TabbarItem).use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(Col).use(Row).use(Search);

Vue.prototype.Clipboard=Clipboard;

Vue.prototype.sendRecord = sendRecord
Vue.prototype.sendPV = sendPV

Vue.config.productionTip = false

//共用样式
import '@/assets/css/common.css'
import '@/templates/css/format.css'
import '@/assets/css/transition.css'
import '@/assets/css/iconfont.css'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js